import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from "axios";
import Swal from "sweetalert2";

export default function CreatePreRecording() {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);

    const [data, setData] = useState({
        title: '',
        description: '',
        photoname: '',
        photo: null
    });
    const [pricing, setPricing] = useState([
        { duration: "1 Month", rupees: '', doller: '' },
        { duration: "3 Month", rupees: '', doller: '' },
        { duration: "6 Month", rupees: '', doller: '' },
        { duration: "12 Month", rupees: '', doller: '' },
        { duration: "Life time", rupees: '', doller: '' }
    ]);

    const handlePriceChange = (index, field, value) => {
        const updatedPricing = [...pricing];
        updatedPricing[index][field] = value;
        setPricing(updatedPricing);
    };
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    const handlePhotoChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];

        if (file) {
            const maxSizeInBytes = 5 * 1024 * 1024;
            if (file.size > maxSizeInBytes) {
                Swal.fire({
                    title: "File size exceeds 5 MB",
                    icon: "warning",
                });
                return;
            }
            setSelectedFile(URL.createObjectURL(file));
            setData({
                ...data,
                [name]: file,
                photoname: file.name,
            });
        }
    };
    const handleUpload = async () => {

        if (!file) return;

        setLoading(true);
        const chunkSize = 5 * 1024 * 1024; // 5MB
        const totalChunks = Math.ceil(file.size / chunkSize);

        for (let i = 0; i < totalChunks; i++) {
            const chunk = file.slice(i * chunkSize, (i + 1) * chunkSize);
            await uploadChunk(chunk, i, totalChunks);
            // setUploadProgress(((i + 1) / totalChunks) * 100);
        }
    };

    const uploadChunk = async (chunk, chunkIndex, totalChunks) => {
        const formData = new FormData();
        formData.append('chunk', chunk);
        formData.append('chunkIndex', chunkIndex);
        formData.append('totalChunks', totalChunks);
        formData.append('fileName', file.name);
        formData.append('title', data.title);
        formData.append('description', data.description);
        formData.append('photoname', data.photoname);
        formData.append('pricing', JSON.stringify(pricing));

        if (chunkIndex === 0) {
            formData.append('photo', data.photo);
        }
        const res = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}/createRecorded`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((chunkIndex + (progressEvent.loaded / progressEvent.total)) / totalChunks * 100);
                setUploadProgress(percentCompleted);
            }
        });

        if (res.status === 201) {
            Swal.fire({
                icon: "success",
                title: "Pre Recorded Class Inserted Successfully",
                timer: 1500,
            }).then(() => {
                navigate("/pre-recording");
            });
            setLoading(false);
        }
    };

    return (
        <div className="page-wrapper">
            <div className="content">
                <form>
                    <div className="row">
                        <nav
                            aria-label="breadcrumb"
                            style={{ "--bs-breadcrumb-divider": "none" }}
                        >
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/pre-recording">Pre Recorded Classes </Link>/
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Add Pre Recorded Classes
                                </li>
                            </ol>
                        </nav>

                        <div className="col-lg-12 col-sm-12">
                            <h5>Add Pre Recorded Classes</h5>

                            <div className="row">
                                <div className="col-lg-3">
                                    <label>Title</label>
                                    <input type="text" name="title" className="form-control" onChange={handleInputChange} placeholder="Enter Title" required />
                                </div>
                                <div className="col-lg-3">
                                    <div className="form-group">
                                        <label>Description</label>
                                        <textarea
                                            type="text"
                                            name="description"
                                            className="form-control"
                                            onChange={handleInputChange}
                                            placeholder="Description"
                                            required
                                            style={{ background: 'white' }}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <label>Video</label>
                                    <input type="file" name="video"
                                        // accept="video/*"
                                        accept=".mp4, .mkv, .avi, .mov, .webm, .flv, .ogv, .wmv"
                                        className="form-control" required onChange={handleFileChange} />
                                </div>

                                <div className="col-md-3">
                                    <div className="file-input">
                                        <label>Photo</label><br />
                                        <input
                                            type="file"
                                            name="photo"
                                            id="file-input"
                                            accept="image/*"
                                            className="file-input__input"
                                            onChange={handlePhotoChange} // Handle file selection
                                        />
                                        <label className="file-input__label" htmlFor="file-input">
                                            <i className="fa-solid fa-upload"></i>
                                            <span>Upload Image</span>
                                        </label>
                                    </div>
                                    {selectedFile && (
                                        <div>
                                            <div>
                                                <img src={selectedFile} alt="Selected" style={{ width: '295px', height: '197px', objectFit: 'contain', borderRadius: '20px', border: '1px solid #d5d5d5' }} />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className='col-md-9'>
                                    <div className="schedule-details mt-5">
                                        <table style={{ textAlign: 'center', width: '100%' }}>
                                            <thead>
                                                <tr className="schedule-content" style={{ backgroundColor: '#bd934c' }}>
                                                    <th className="time mb-0" style={{ fontWeight: '700' }}>Duration</th>
                                                    {pricing.map((item) => (
                                                        <th key={item.duration} className="time mb-0" style={{ fontWeight: '700' }}>
                                                            {item.duration}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="schedule-content">
                                                    <td className="time mb-0" style={{ textAlign: 'center' }}>Rupees (₹)</td>
                                                    {pricing.map((item, index) => (
                                                        <td key={index} className="title mb-0" style={{ textAlign: 'center' }}>
                                                            <input
                                                                className="form-control"
                                                                type="number"
                                                                value={item.rupees}
                                                                onChange={(e) => handlePriceChange(index, 'rupees', e.target.value)}
                                                                style={{ width: "80px", textAlign: "center" }}
                                                            />
                                                        </td>
                                                    ))}
                                                </tr>
                                                <tr className="schedule-content">
                                                    <td className="time mb-0" style={{ textAlign: 'center' }}>Dollar ($)</td>
                                                    {pricing.map((item, index) => (
                                                        <td key={index} className="title mb-0" style={{ textAlign: 'center' }}>
                                                            <input
                                                                className="form-control"
                                                                type="number"
                                                                value={item.doller}
                                                                onChange={(e) => handlePriceChange(index, 'doller', e.target.value)}
                                                                style={{ width: "80px", textAlign: "center" }}
                                                            />
                                                        </td>
                                                    ))}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="btn-path">
                                    <Link to="/pre-recording" className="btn btn-cancel me-3">Back</Link>
                                    {
                                        loading
                                            ?
                                            <>
                                                <button className="btn btn-primary" type="button" disabled>
                                                    <div
                                                        role="progressbar"
                                                        style={{ width: `${uploadProgress}%`, color: 'white' }}
                                                        aria-valuenow={uploadProgress}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                    >
                                                        {uploadProgress.toFixed(2)}%
                                                    </div>
                                                </button>
                                            </>
                                            :
                                            <button onClick={handleUpload} className="btn btn-primary">Upload Video</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
